/**
 * Hook to set up Clerk authentication with the API client.
 * This should be called once at the app root level.
 */

import { useEffect } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { setAuthTokenGetter } from '../api';
import { setSwrAuthTokenGetter } from '../swr-config';

// Check if Clerk is configured
const clerkEnabled = !!(import.meta as any).env?.VITE_CLERK_PUBLISHABLE_KEY;

export function useAuthSetup() {
  // Only call useAuth if Clerk is enabled (ClerkProvider is present)
  // This prevents errors when running without authentication
  const auth = clerkEnabled ? useAuth() : { getToken: null, isLoaded: true, isSignedIn: false };
  const { getToken, isLoaded, isSignedIn } = auth;

  useEffect(() => {
    if (isLoaded) {
      console.log('[useAuthSetup] Setting up token getter. isSignedIn:', isSignedIn, 'clerkEnabled:', clerkEnabled);
      // Set up the token getter for API calls
      const tokenGetter = async () => {
        if (!clerkEnabled || !getToken) {
          // No auth configured, return null token
          return null;
        }
        try {
          const token = await getToken();
          console.log('[useAuthSetup] getToken returned:', token ? 'token present' : 'null');
          return token;
        } catch (err) {
          console.error('[useAuthSetup] getToken error:', err);
          return null;
        }
      };
      setAuthTokenGetter(tokenGetter);
      setSwrAuthTokenGetter(tokenGetter);
    }
  }, [getToken, isLoaded, isSignedIn]);

  return { isLoaded };
}
